import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";

const Login = () => {
    const { user } = useSelector((state) => state.auth);
    const origin = window.location.origin;
    const redirectUrl = `${window.location.origin}/test`;
    const userId = user?._id;
    const baseUrl = window.location.origin.includes("localhost:3000")
        ? "http://localhost:8090"
        : window.location.origin;

    const googleLogin = () => {
        const url = `${baseUrl}/google?origin=${encodeURIComponent(origin)}&userId=${encodeURIComponent(userId)}`;
        window.location.href = url;
    };

    const microsoftLogin = () => {
        const url = `${baseUrl}/microsoft?redirectUrl=${encodeURIComponent(redirectUrl)}&userId=${encodeURIComponent(userId)}`;
        window.location.href = url;
    };

    return (
        <div>
            <h1>Login</h1>
            <button onClick={googleLogin}>Login with Google</button>
            <button onClick={microsoftLogin} style={{ margin: '10px' }}>
                Login with Microsoft
            </button>
        </div>
    );
};

export default Login;